import { createAction } from '@reduxjs/toolkit'

export const createAsyncAction = <R, S, C>(name: string) => ({
  request: createAction<R>(`${name}_REQUEST`),
  success: createAction<S>(`${name}_SUCCESS`),
  failure: createAction<C>(`${name}_FAILURE`)
})
